import 'css-chunk:src/feature/provision/LocationSelector.module.scss';export default {
  "root": "LocationSelector_root",
  "searchFieldWrapper": "LocationSelector_searchFieldWrapper"
};